import React, { useEffect, useState } from "react";
import { api, fmtINR, fmtDate } from "@/lib/api";

export default function Vouchers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/vouchers").then((r) => setRows(r.data)); }, []);

  return (
    <div className="space-y-5 lb-fade" data-testid="vouchers-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Ledger</div>
        <h1 className="font-display font-extrabold text-3xl tracking-tight">Journal Vouchers</h1>
        <p className="text-neutral-600 text-sm mt-1">Every transaction posts a balanced double-entry voucher.</p>
      </div>

      <div className="space-y-3">
        {rows.map((v) => (
          <div key={v.id} className="lb-card p-4" data-testid={`voucher-${v.id}`}>
            <div className="flex items-center justify-between border-b border-neutral-100 pb-2">
              <div>
                <div className="text-xs text-neutral-500 font-semibold uppercase tracking-wider">{v.ref_type}</div>
                <div className="font-semibold text-sm mt-1">{v.narration}</div>
              </div>
              <div className="text-right">
                <div className="font-mono text-xs text-neutral-500">{fmtDate(v.date)}</div>
                <div className="font-mono font-bold">{fmtINR(v.total)}</div>
              </div>
            </div>
            <table className="w-full mt-2">
              <thead>
                <tr className="text-[10px] uppercase tracking-wider text-neutral-500">
                  <th className="text-left py-1">Ledger</th><th className="text-left py-1">Party</th>
                  <th className="text-right py-1">Debit</th><th className="text-right py-1">Credit</th>
                </tr>
              </thead>
              <tbody>
                {v.entries.map((e, i) => (
                  <tr key={i} className="text-sm">
                    <td className="py-1">{e.ledger}</td>
                    <td className="py-1 text-neutral-600">{e.party || "—"}</td>
                    <td className="py-1 text-right font-mono">{e.debit ? fmtINR(e.debit) : "—"}</td>
                    <td className="py-1 text-right font-mono">{e.credit ? fmtINR(e.credit) : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        {!rows.length && <div className="lb-card p-10 text-center text-neutral-500">No vouchers yet</div>}
      </div>
    </div>
  );
}
